'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import makeAsyncModal from 'DesignComponents/modals/makeAsyncModal';
import { FolderPropTypes } from 'DesignData/propTypes/finder';
const NewProjectWizard = makeAsyncModal(() => import(
/* webpackChunkName: "modals" */
'DesignFinderUI/components/modals/NewProjectWizard'));
export default function withNewProjectWizard(WrappedComponent) {
  class HighOrderWithNewProjectWizard extends Component {
    constructor(props) {
      super(props);

      this.componentDidUpdate = prevProps => {
        if (this.props.folderId !== prevProps.folderId) {
          this.setState({
            folderId: this.props.folderId
          });
        }
      };

      this.handleNewProjectCallback = () => {
        this.setState({
          open: false
        });
      };

      this.handleNewProjectClick = () => {
        this.setState({
          open: true
        });
      };

      this.renderNewProjectWizard = () => {
        if (!this.state.open) {
          return null;
        }

        return /*#__PURE__*/_jsx(NewProjectWizard, {
          callback: this.handleNewProjectCallback,
          folderId: this.state.folderId,
          onFolderChange: evt => {
            this.setState({
              folderId: evt.target.value.id
            });
          }
        });
      };

      this.state = {
        open: false,
        folderId: props.folderId
      };
    }

    render() {
      const renderedNewProjectWizard = this.renderNewProjectWizard();
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, this.props, {
        NewProjectWizard: renderedNewProjectWizard,
        onNewProjectClick: this.handleNewProjectClick
      }));
    }

  }

  HighOrderWithNewProjectWizard.propTypes = {
    folderId: FolderPropTypes.folderId
  };
  HighOrderWithNewProjectWizard.defaultProps = {
    folderId: null
  };
  return HighOrderWithNewProjectWizard;
}